export enum SnmpVersionCode {
    V1 = 0,
    V2 = 1,
    V2U = 2,
    V3 = 3
}
